import { produce } from 'immer';
import {
  INICIAR_VENTANA_TRAZADORA,
  OBTENER_SUPLEMENTOS_TRAZADORA_SUCCESS,
  SET_VISIBLE,
} from '../actions/constants/trazadora.constants';
import { convertirDatosVentanaTrazadora } from '../../helpers/modules/trazadora.helper';

const initialState = {
  visible: false,
  datosVentana: null,
};
export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case INICIAR_VENTANA_TRAZADORA: {
      const {
        resultadoSuplementos: { descripcionOficial, datos }, datosSeleccionLente, materialesYBiselados,
      } = payload;
      const datosVentana = convertirDatosVentanaTrazadora({
        ...datosSeleccionLente, descripcionOficial, datosSuplementos: datos, materialesYBiselados,
      });
      return { ...draft, datosVentana, visible: true };
    }
    case SET_VISIBLE: {
      return { ...draft, visible: payload };
    }
    default:
      return draft;
  }
});
